module.exports = __webpack_public_path__ + "media/images/mobile/text-fragment-8bc76ef27646f991434df4edf7008d6f.png";